export const environment = {
    stagging: true,
    // originUrl: 'https://byplayout.betteryearbook.com/',
    production: true,
    originUrl: 'api'
};
